import { Subject } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { Statique } from "./statique";


export class DataTableConfig {
    public dtOptions: any = {};
    public dtTrigger: Subject<any>;

    constructor(URL?: String) {
        let $this = this;
        if (URL != null)

            this.dtOptions = {
                ajax: {
                    "url": URL,
                    "data": {}
                },
                pagingType: 'full_numbers',
                pageLength: 25,
                processing: true,
                stateSave: true,
                scrollX: true,
                // ScrollXInner: "100%",
                //scrollY: "1000px",
                //scrollCollapse: true,
                lengthMenu: [[5, 10, 25, 50], [5, 10, 25, 50]],
                language: {
                    paginate: {
                        first: '<i class="fa fa-angle-double-left"></i>',
                        last: '<i class="fa fa-angle-double-right"></i>',
                        next: '<i class="fa fa-angle-right"></i>',
                        previous: '<i class="fa fa-angle-left"></i>',

                    },
                    processing: "Traitement en cours...",
                    search: "Rechercher&nbsp;:",
                    searchPlaceholder: "Appuyez sur entrer",
                    lengthMenu: "Afficher _MENU_ &eacute;l&eacute;ments",
                    info: "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments",
                    infoEmpty: "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment",
                    infoFiltered: "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
                    infoPostFix: "",
                    loadingRecords: "Chargement en cours...",
                    zeroRecords: "Aucun &eacute;l&eacute;ment &agrave; afficher",
                    emptyTable: "Aucune donn&eacute;e disponible dans le tableau",
                    aria: {
                        sortAscending: ": activer pour trier la colonne par ordre croissant",
                        sortDescending: ": activer pour trier la colonne par ordre d&eacute;croissant"
                    },
                    select: {
                        rows: {
                            _: "%d lignes séléctionnées",
                            0: "Aucune ligne séléctionnée",
                            1: "1 ligne séléctionnée"
                        }
                    }
                },
                dom: 'lBfrtip',
                buttons: [
                    {
                        extend: 'colvis',
                        //columns: ':gt(0)'
                    },
                ],
                colReorder: {
                    order: [1, 0, 2],
                    //fixedColumnsRight: 2
                },
            };

        else
            this.dtOptions = {
                pagingType: 'full_numbers',
                pageLength: 5,
                stateSave: true,
                lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, "All"]],
                language: {
                    paginate: {
                        first: "Premier",
                        last: "Dernier",
                        next: "Suivant",
                        previous: "Précédant",
                    },
                    processing: "Traitement en cours...",
                    search: "Rechercher&nbsp;:",
                    lengthMenu: "Afficher _MENU_ &eacute;l&eacute;ments",
                    info: "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments",
                    infoEmpty: "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment",
                    infoFiltered: "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
                    infoPostFix: "",
                    loadingRecords: "Chargement en cours...",
                    zeroRecords: "Aucun &eacute;l&eacute;ment &agrave; afficher",
                    emptyTable: "Aucune donn&eacute;e disponible dans le tableau",
                    aria: {
                        sortAscending: ": activer pour trier la colonne par ordre croissant",
                        sortDescending: ": activer pour trier la colonne par ordre d&eacute;croissant"
                    },
                    select: {
                        rows: {
                            _: "%d lignes séléctionnées",
                            0: "Aucune ligne séléctionnée",
                            1: "1 ligne séléctionnée"
                        }
                    }

                },
                dom: 'Clfrtip',
                buttons: [
                    'colvis',
                ],
                colReorder: {
                    //order: [1, 0, 2],
                    //fixedColumnsRight: 2
                }
            };

        this.dtTrigger = new Subject();
    }

    rerender(dtElement: DataTableDirective, columns = null): void {
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            if (columns)
                this.dtOptions.columns = columns;

            this.dtTrigger.next();
        });
    }
    /**
     * Methodes utilitaires pour manipuler les données de la datatable
     */
    static getState(dtElement: DataTableDirective) {
        if (dtElement)
            return Statique.cloneObject(dtElement["dt"]["state"]());
        return null;
    }
    static getRowIndexByEntityId(dtElement, id: number, entityIdName: string) {
        let data = dtElement["dt"]["rows"]().data();
        let i, n = data.length;
        for (i = 0; i < n; i++) {
            if (data[i][entityIdName] === id)
                return i;
        }
        return null;
    }
    static getDataRow(dtElement: DataTableDirective, id: number, entityIdName: string = null) {
        let data = null;
        let index = entityIdName ? this.getRowIndexByEntityId(dtElement, id, entityIdName) : id;
        if (index !== undefined && index != null && dtElement && dtElement["dt"]["row"](index)) {
            data = dtElement["dt"]["row"](index).data();
        }
        return Statique.cloneObject(data);
    }
    static setDataRow(dtElement: DataTableDirective, data: any, id: number, entityIdName: string = null) {
        let index = entityIdName ? this.getRowIndexByEntityId(dtElement, id, entityIdName) : id;
        if (index !== undefined && index != null && dtElement && data && dtElement["dt"]["row"](index)) {
            dtElement["dt"]["row"](index).data(data);
        }
    }

    static getStateColumns(dtElement: DataTableDirective) {
        let state = this.getState(dtElement);
        let result = [];
        if (state) {
            let columns = dtElement["dt"]["settings"]().init().columns;
            let i, n = columns.length;
            for (i = 0; i < n; i++) {
                if (state.columns[i] && columns[i].name && columns[i].name.trim().length > 0 && columns[i].name.indexOf('btn-') < 0 && state.columns[i].visible) {
                    result.push({
                        title: columns[i].title,
                        name: columns[i].name,
                        order: state.ColReorder.findIndex(colIndex => colIndex == i),
                    });
                }
            }
            result = result.sort((it1, it2) => {
                return it1.order - it2.order;
            });
            return Statique.cloneObject(result);
        }
    }
    static getSettingsColumns(dtElement: DataTableDirective) {
        // window["dtElement"] = dtElement;
        // window["config"] = DataTableConfig;

        let columns = dtElement["dt"]["settings"]().init().columns;

        return Statique.cloneObject(columns);
    }

}



// WEBPACK FOOTER //
// ./src/app/utils/dataTableConfig.ts